import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import api from './services/WebService'
import Notifications from '@kyvg/vue3-notification'
import helperService from './services/HelperService';
import shareService from './services/ShareService';
import "./services/ValidationRules";
import store from './services/StoreService';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { createI18n } from "vue-i18n";
import messages from "./mess";
import VueCountdown from '@chenfengyuan/vue-countdown';

const i18n = createI18n({
    locale: 'en',
    messages: messages,
});
const app = createApp(App);
app.use(i18n); // 👈 Yeh pehle hona chahiye
app.component(VueCountdown.name, VueCountdown);
library.add(fas);
app.component('font-awesome-icon', FontAwesomeIcon);
app.use(router)
app.use(Notifications)
app.use(store);
app.config.globalProperties.$helperService = helperService;
app.config.globalProperties.$api = api;
app.config.globalProperties.$shareService = shareService;

app.directive('click-outside', {
    mounted(el, binding) {
        el.clickOutsideEvent = function (event) {
            if (!(el === event.target || el.contains(event.target))) {
                binding.value(event, el);
            }
        };
        document.body.addEventListener('click', el.clickOutsideEvent);
    },
    unmounted(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent);
    }
});

app.mount('#app'); // 